<template>
  <div class="card">
    <div class="card-header">
      <h5 class="card-title">Logged In Today</h5>
    </div>
    <div class="card-body">
      <el-table class="table-striped indexed-table-column-width"
                :data="tableData"
                :max-height="tableHeight(400)"
                border
                style="table-layout:fixed; width:100%;">
        <el-table-column
          :width="indexColumnWidth"
          align="center"
          label="#"
          type="index">
        </el-table-column>
        <el-table-column
          label="Message"
          min-width="130">
          <template slot-scope="props">
            <div class="no-wrap-ellipsis">{{ props.row.message }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="Time"
          min-width="150">
          <template slot-scope="props">
            <div class="no-wrap-ellipsis">{{ props.row.createdAt | formatDateTime }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="col-sm-12 pagination-info">
        <span class="category">Showing {{total}} entries</span>
      </div>
    </div>
  </div>
</template>

<script>
  import Constants from 'src/utilities/constants'
  import {todayStart, todayEnd, setIndexColumnWidth, getTableHeight} from 'src/utilities/utils'
  import {OK} from 'http-status-codes'

  export default {
    data() {
      return {
        tableData: [],
        constants: Constants
      }
    },
    computed: {
      total() {
        return this.tableData.length
      },
      indexColumnWidth() {
        return setIndexColumnWidth(this.tableData.length)
      }
    },
    methods: {
      tableHeight(buffer) {
        return getTableHeight(buffer)
      }
    },
    async beforeMount() {
      const response = await this.$store.dispatch('logs/fetchByEntityTypeAndLogLevelAndCreatedAt', {
        entityType: Constants.ENTITIES.USER,
        level: Constants.LOG_LEVELS.INFO,
        createdAt: [
          todayStart(),
          todayEnd()
        ]
      })

      if (OK === response.status) {
        this.tableData = response.data
      }
    }
  }
</script>

<style scoped>
  .no-wrap-ellipsis {
    width: 0;
    min-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
